import { FC, useCallback, useMemo, useReducer } from 'react';
import { ToastWrapper } from '@livechat/design-system-react-components';

import { uniqueId } from 'helpers/string';

import { NotificationsContext } from './context';
import { initialState, reducer } from './reducer';
import { ShowToastProps } from './types';

type Props = {
  children: React.ReactNode;
};

export const NotificationsProvider: FC<Props> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const hideToast = useCallback(
    (id: string) => {
      dispatch({
        type: 'HIDE_TOAST',
        payload: {
          id,
        },
      });
    },
    [dispatch]
  );

  const showToast = useCallback(
    ({ autoHideDelayTime = 4000, content, variant, action }: ShowToastProps) => {
      const id = uniqueId();

      dispatch({
        type: 'SHOW_TOAST',
        payload: {
          id,
          action: action as any,
          content: content as string,
          kind: variant,
          removable: true,
          onClose: () => hideToast(id),
        },
      });

      if (autoHideDelayTime) {
        setTimeout(() => hideToast(id), autoHideDelayTime);
      }
    },
    [dispatch, hideToast]
  );

  const value = useMemo(
    () => ({
      showToast,
    }),
    [showToast]
  );

  return (
    <NotificationsContext.Provider value={value}>
      <>
        <ToastWrapper toasts={state} className="toast-message" />
        {children}
      </>
    </NotificationsContext.Provider>
  );
};
